<div class="login-container">
  <div class="login-box">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-8 col-md-6 col-lg-4"> <om-login-form></om-login-form> </div>
      </div>
    </div>
  </div>
</div>
